import React, { useEffect, useRef, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import {
  Col,
  Row,
  Card,
  UncontrolledPopover,
  PopoverBody,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledTooltip,
  Button,
} from "reactstrap"
import { useNavigate } from "react-router-dom"
import UpdateTable from "../../../components/Common/UpdatedTable"
import action from "../../../assets/icons/action.svg"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import closeIcon from "../../../assets/icons/close.svg"
import CustomerFilter from "./filter"
import {
  searchCustomer,
  updateCustomerStatus,
} from "../../../services/projectManager/customer"
import NumberFormat from "../../../utils/numberFormat"
import MobileNumberFormat from "../../../utils/mobilenumberformat"
import { useLocation } from "react-router-dom"

const Customer = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Customer${companyname ? ` | ${companyname}` : "MEP -Hub"}`
  const [editClass, setEditClass] = useState({
    modal: false,
    value: "",
    id: "",
  })
  const [refresh, setRefresh] = useState(0)
  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)
  const [dataPerPage, setDataPerPage] = useState(25)
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)

  console.log("viewData", viewData)

  const crumb = localStorage.getItem("tagLine") || "";

  const navigate = useNavigate()
  const toggle = () => setModal(!modal)

  const handleUpdate = () => {
    setRefresh(refresh + 1)
  }
  const handleReset = () => {
    setEditClass({
      modal: false,
      value: "",
      id: "",
    })
  }

  const [classData, setClassData] = useState()
  const [status, setStatus] = useState("")
  const [search, setSearch] = useState("")
  const [customerType, setCustomerType] = useState("")
  const [page, setPage] = useState("")
  const [financial, setFinancial] = useState(true)

  const handleEdit = item => {
    navigate(`/project-customer/edit/${item?.id}`)
  }
  const handleView = item => {
    setViewData(item)
    toggle()
  }

  const handleActivate = async item => {
    try {
      const response = await updateCustomerStatus(item)
      toastSuccess(response?.message)
      setRefresh(refresh + 1)
    } catch (err) {
      toastError(err?.message)
    }
  }

  const columns = [
    {
      label: "Type",
      renderCell: item => item?.customer_type?.label,
    },
    {
      label: "Code",
      renderCell: item => {
        return (
          <div onClick={() => handleView(item)} className="pointer fw-bold">
            {item?.customer_code}
          </div>
        )
      },
    },
    {
      label: "Customer Name",
      renderCell: item => (
        <div>
          <div
            className="capitalize-letter tbl-word-break"
            id={`uncontroled_${item?.id}`}
          >
            {item?.customer_name?.length > 25 ? (
              <div>{item?.customer_name?.slice(0, 25)}...</div>
            ) : (
              <div>{item?.customer_name}</div>
            )}
          </div>
          {item?.customer_name?.length > 25 && (
            <UncontrolledPopover
              placement="bottom"
              target={`uncontroled_${item?.id}`}
              trigger="hover"
            >
              <PopoverBody>
                <div>{item?.customer_name}</div>
              </PopoverBody>
            </UncontrolledPopover>
          )}
        </div>
      ),
      sortKey: "customer_name",
    },
    {
      label: "Contact Person",
      renderCell: item => (
        <div className="capitalize-letter">
          <div id={`contact-person-popover-${item?.id}`}>
            {item?.contact_person?.length > 20
              ? `${item.contact_person.slice(0, 20)}...`
              : item?.contact_person || "-"}
          </div>
          {item?.contact_person?.length > 20 && (
            <UncontrolledPopover
              target={`contact-person-popover-${item?.id}`}
              trigger="hover"
              placement="bottom"
            >
              <PopoverBody>{item?.contact_person || "-"}</PopoverBody>
            </UncontrolledPopover>
          )}
        </div>
      ),
      sortKey: "contact_person",
    },
    {
      label: "Contact Number",
      renderCell: item => MobileNumberFormat("+" + item?.customer_number),
    },
    {
      label: "Status",
      renderCell: item => (
        <div>
          <span
            className={`font-13 ${
              item?.status === 1 ? "status-active" : "status-inactive"
            }`}
          >
            {item?.status === 1 ? "Active" : "Inactive"}
          </span>
        </div>
      ),
    },
    {
      label: "Action",
      renderCell: item => (
        <>
          <div>
            <span id={`PopoverLegacy-${item?.id}`}>
              <img src={action} alt="" className="pointer" />
            </span>
          </div>
          <UncontrolledPopover
            placement="bottom"
            target={`PopoverLegacy-${item?.id}`}
            trigger="legacy"
          >
            <PopoverBody>
              {item?.status === 1 && (
                <div
                  className="table-popup-content"
                  onClick={() => handleEdit(item)}
                >
                  Edit
                </div>
              )}
              <div
                className={`${
                  item?.status === 1 ? "popover-border" : ""
                } table-popup-content`}
                onClick={() => handleActivate(item?.id)}
              >
                {item?.status === 1 ? "Deactivate" : "Activate"}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  useEffect(() => {
    const fetchClass = async () => {
      const response = await searchCustomer({
        params: `${status == "0" || status == "1" ? `&status=${status}` : ""}${
          search ? `&searchText=${search}` : "&searchText"
        }${`&sortOrder=asc`}${
          customerType == "0" ||
          customerType == "1" ||
          customerType == "2" ||
          customerType == "3" ||
          customerType == "4"
            ? `&customer_type=${customerType}`
            : ""
        }${page ? `&page=${page}` : ""}${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}`,
      })
      // setClassData(response)
      const newData = response?.data?.data || [];

      setClassData(prev =>
        page > 1 && prev
          ? {
            ...response,
            data: {
              ...response.data,
              data: [...(prev.data?.data || []), ...newData],
            },
          }
          : response
      );
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false;
    }
    fetchClass()
    // ${`&financial=${financial}`}
  }, [refresh, status, search, customerType, page, dataPerPage, financial])

  const handleStatusChange = id => {
    setStatus(id)
    setPage(1)
  }

  const handleCatChange = id => {
    setCustomerType(id)
    setPage(1)
  }
  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }
  const handleTblRefresh = e => {
    setRefresh(refresh + 1)
  }

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = (e) => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
      
      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < classData?.data?.last_page
        ) {
          isLoadingRef.current = true;
          setIsLoadingNextPage(true);
          setPage(prev => prev + 1);
        }
      }, 200);
    };
    
    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    
    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, [classData, page]);
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            <Breadcrumbs
              title="Project Management"
              breadcrumbObject={[
                { title: "Project Management", link: "/project" },
                { title: crumb || "Master", link: "/project" },
                { title: "Customers", link: "/project-customer" },
              ]}
            />
            <Button
              color="primary"
              className="px-2 mb-3 me-2"
              onClick={() => navigate("/project-customer/add")}
            >
              +&nbsp; Customer
            </Button>
          </div>
          <Card className="me-2 px-2 pb-2">
            <CustomerFilter
              handleStatusChange={handleStatusChange}
              handleSearchChange={handleSearchChange}
              handleCatChange={handleCatChange}
              handleTblRefresh={handleTblRefresh}
              handleFinacialChange={handleFinacialChange}
              sampleUrl={"download/customer.xlsx"}
              importUrl={"customer/import"}
              isImport={true}
            />
            <hr className="table-divide" />
            <Row className="mt-2 ever-rise-table">
              <Col xs={12}>
              <div ref={tableContainerRef} style={{ height: "480px", overflowY: "auto" }}>
                {classData && (
                  <UpdateTable
                    className="mt-5"
                    nodes={classData?.data?.data}
                    paginate={classData?.data}
                    columns={columns}
                    CurrentPage={page}
                    handlePagination={handlePaginate}
                    handleSizePerPage={handleSizePerPageChange}
                    tableWidth="15% 15% 20% 15% 15% 10% 10%"
                    // mobileWidth="30% 30% 40% 30% 30% 20% 10%"
                    mobileWidth="15% 15% 20% 15% 15% 10% 10%"
                    isLoading={isLoadingNextPage}
                    hidePaginate={true}
                  />
                )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle} size="lg" unmountOnClose={false}>
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-4">Details</h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggle}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Type
              </Col>
              <Col className="primary-text">
                {viewData?.customer_type?.label}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Code
              </Col>
              <Col className="primary-text">{viewData?.customer_code}</Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Customer Name
              </Col>
              <Col className="primary-text">
                <div
                  className="capitalize-letter cursor-pointer"
                  id={`customer-name-popover-${viewData?.id}`}
                >
                  {viewData?.customer_name?.length > 35
                    ? `${viewData.customer_name.slice(0, 35)}...`
                    : viewData?.customer_name}
                </div>
                {viewData?.customer_name?.length > 35 && (
                  <UncontrolledTooltip
                    placement="bottom"
                    target={`customer-name-popover-${viewData.id}`}
                    trigger="hover"
                    innerClassName="popover-custom"
                  >
                    {viewData.customer_name}
                  </UncontrolledTooltip>
                )}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Email ID
              </Col>
              <Col className="primary-text">
                {viewData?.email_id ? viewData?.email_id : "-"}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Contact Person
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">
                  {viewData?.contact_person ? viewData?.contact_person : "-"}
                </div>
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Contact Number
              </Col>
              <Col className="primary-text">
                {viewData?.customer_number
                  ? MobileNumberFormat("+" + viewData?.customer_number)
                  : "-"}
              </Col>
            </Row>
            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Designation
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">
                  {viewData?.contact_person_designation
                    ? viewData?.contact_person_designation
                    : "-"}
                </div>
              </Col>
            </Row>
            {viewData?.contact_person_two != null && (
              <Row className="py-3 ms-3">
                <Col lg={3} className="secondary-text">
                  Contact Person Two
                </Col>
                <Col className="primary-text">
                  <div className="capitalize-letter">
                    {viewData?.contact_person_two}
                  </div>
                </Col>
              </Row>
            )}
            {viewData?.customer_number_two != null && (
              <Row className="py-3 ms-3">
                <Col lg={3} className="secondary-text">
                  Contact Number Two
                </Col>
                <Col className="primary-text">
                  {MobileNumberFormat("+" + viewData?.customer_number_two)}
                </Col>
              </Row>
            )}
            {viewData?.contact_person_designation_two != null && (
              <Row className="py-3 ms-3">
                <Col lg={3} className="secondary-text">
                  Designation Two
                </Col>
                <Col className="primary-text">
                  <div className="capitalize-letter">
                    {viewData?.contact_person_designation_two}
                  </div>
                </Col>
              </Row>
            )}

            <Row className="py-3 ms-3">
              <Col lg={3} className="secondary-text">
                Address
              </Col>
              <Col className="primary-text">
                <div className="capitalize-letter">
                  {viewData?.address ? viewData?.address : "-"}
                </div>
              </Col>
            </Row>
          </ModalBody>
        </>
      </Modal>
    </React.Fragment>
  )
}

export default Customer
